module.exports = __webpack_public_path__ + "img/Just-365-Days-Guarantee.b008c927.jpg";